<template>
  <Tab no-help @close="removeCurrent">
    <template #toolbar-items>
      <!-- ------------------------ list ------------------------ -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page === 'list'"
        icon="fa-list"
        name="list"
      ></TabToolbarButton>
      <!-- ------------------------ validate ------------------------ -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page === 'validate'"
        icon="fa-check"
        name="validate"
      ></TabToolbarButton>
    </template>
    <template #container>
      <!-- ------------------------ list ------------------------ -->
      <TabPage :menu="menu" :page="page" name="list" documentation-path="menu/reviews/list">
        <template #content>
          <List />
        </template>
      </TabPage>

      <!-- ------------------------ validate ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="menu/user/validate/page" name="validate">
        <template #content>
          <ValidatePublications />
        </template>
      </TabPage>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"
import List from "./List"
import ValidatePublications from "@/components/me/tabs/Reviews/ValidatePublications"

export default {
  name: "Reviews",
  mixins: [tab],
  components: {
    List,
    ValidatePublications,
  },
  data: () => ({
    pages: ["list", "validate"],
    menu: "reviews",
    page: "list",
  }),
}
</script>
